import { Layout, Typography, Card, Button, Form } from 'antd';
import React from "react";
import logoImage from "../images/logo-black.png";
import "../importData/Homepage.css";

import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();


  return (
    <>
      <main className="min-h-screen newHomeContainer">
        <div className='innerHeader'>
            <div className="landHeader">
            <div className="container px-4">
                <div className="logoWraps">
                <span className="txtLogo font-bold" onClick={() => navigate("/home")} >Ezwinds</span>
                </div>

                <div className="btnWraps">
                <Button
                    size="lg"
                    variant="hero"
                    className="text-base logBtns"
                    onClick={() => navigate("/login")}
                >
                    Log In{" "}
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-5 w-5"
                    >
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </Button>

                <Button
                    size="lg"
                    variant="heroOutline"
                    className="text-base logBtns ml_space"
                    onClick={() => navigate("/register")}
                >
                    Register{" "}
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-5 w-5"
                    >
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </Button>
                </div>
            </div>
            </div>
            <div class="absolute inset-0 bg-hero-gradient"></div>
        </div>
        {/* Header End */}


        <section className='privacyWraper py-5'>
            <div className='container'>
                <h1 className='mb-4'>Privacy Policy for Ezwinds Digital TV Display Application</h1>
                <p><strong>Effective Date: 11/23/2025</strong></p>
                <p>
                    Ezwinds (“we,” “our,” or “us”) provides a Digital TV Display Application (“Application”) designed for stores to showcase promotions, menus, events, and announcements. We are committed to protecting the privacy of our customers, store partners, and end-users. This Privacy Policy explains what information we collect, how we use it, how we protect it, and the rights available to our users.
                </p>
                <h3>1. Information We Collect</h3>
                <p>
                    We collect only the minimum data necessary to operate and improve the Application:
                </p>
                <h3>a. Store Account Information:</h3>
                <p>
                    When a store registers, we may collect business name, contact details, email address, billing information, and login credentials.
                </p>
                <h3>b. Display Content Data:</h3>
                <p>
                    Stores may upload media such as images, videos, menus, event details, schedules, or promotional text. All content remains the property of the store.
                </p>
                <h3>c. Device & Technical Data:</h3>
                <p>
                    We may collect non-personal device information such as TV model, operating system version, IP address, app performance metrics, crash logs, and diagnostic data.
                </p>
                <h3>d. Usage Information:</h3>
                <p>
                    We may collect anonymized engagement metrics, including content playback time, frequency of updates, or display performance analytics.
                    <br></br>
                    The Application does not collect customer-facing video footage, audio, or biometric data from within the store. It does not use cameras or microphones.
                </p>
                <h3>2. How We Use Information</h3>
                <p>
                   We use collected information to:
                </p>
                <ul>
                    <li>Provide and maintain the Application</li>
                    <li>Enable content scheduling and remote updates</li>
                    <li>Process payments and manage subscriptions</li>
                    <li>Improve stability, performance, and user experience</li>
                    <li>Offer customer support</li>
                    <li>Conduct analytics in anonymized form</li>
                </ul>
                <p>
                   We do not sell personal data to third parties.
                </p>
                <h3>3. How We Share Information</h3>
                <p>
                   We may share information with:
                </p>
                <ul>
                    <li>Verified service providers (e.g., cloud hosting, billing processors) under strict confidentiality</li>
                    <li>Legal authorities only when required by law</li>
                </ul>
                <p>
                   We never share or disclose store-uploaded content without explicit permission.
                </p>
                <h3>4. Data Security</h3>
                <p>
                   We use industry-standard security protocols, encrypted data transmission, and restricted access controls to protect all stored information.
                </p>
                <h3>5. Data Retention</h3>
                <p>
                   We retain account and device data only as long as necessary to provide services. Stores may request deletion of their account or content at any time.
                </p>
                <h3>6. User Rights</h3>
                <p>
                  Stores may access, update, or delete their information; request data export; or raise privacy concerns by contacting <a href='mailto:info@ezwinds.com.'>info@ezwinds.com.</a>
                </p>
                <h3>7. Changes to This Policy</h3>
                <p>
                  We may update this Privacy Policy periodically. Continued use of the Application indicates acceptance of any revisions.
                </p>
            </div>
        </section>



    
        {/* FOOTER Start*/}
        <footer className="bg-card border-t border-border pt-4">
        <div className="container px-4 pt-5 py-2 md:py-16">
            <div className="ftrGrid grid md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2 logoParts">
                <div className="flex items-center gap-2 mb-3">
                {/* <span className="text-xl font-bold text-foreground txtLogo">Ezwinds</span> */}
                <img 
                    src={logoImage} 
                    alt="logo" 
                    className="logoImg"
                    /> 
                </div>
                <p>
                Transform your retail space with powerful digital advertising solutions that engage customers and drive sales
                </p>

                <div className="space-y-3">
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail h-4 w-4"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                    <span><a href='mailto:info@ezwinds.com'>info@ezwinds.com</a></span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone h-4 w-4"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    <span><a href='tel:+12073705346'>+1 207 370 5346</a></span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-4 w-4"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    <span>New York, US</span>
                </div>
                </div>
                
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Product</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Features
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Pricing
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    FAQ
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Demo
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Company</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    About Us
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Careers
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Blog
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Press Kit
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Resources</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Documentation
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    API Reference
                    </a>
                </li>
                <li>
                    <a href="/support" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Support
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Contact
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Legal</h3>
                <ul className="space-y-2">             
                <li>
                    <a href='/privacy-policy' className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Privacy Policy
                    </a>
                </li>
                <li>
                    <a href='/copyright-policy' className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Copyright Policy
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Terms of Service
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Cookie Policy
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    GDPR
                    </a>
                </li>
                </ul>
            </div>
        
            </div>
            
            <div className="border-t border-border mt-4 py-4">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 ftrCopyright">
                <p className="text-sm text-muted-foreground my-1">
                © 2025 Ezwinds. All rights reserved.
                </p>
                <div className="flex items-center gap-6 socilIcons">
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <span className="sr-only">Twitter</span>
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                </a>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <span className="sr-only">LinkedIn</span>
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                </a>
                </div>
            </div>
            </div>
        </div>
        </footer>

        {/* FOOTER End*/}
    </main>

    </>
  );
}
